module.exports = __webpack_public_path__ + "static/media/title-background.3793447d.jpg";